import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { AppGenServiceService } from './app-gen-service.service';
import { CommonService } from './common.service';

@Injectable({
  providedIn: null,
})
export class RuleService {
  //inputData: any;
  constructor(
    private appGenServiceService: AppGenServiceService,
    private commonService: CommonService
  ) {}

  ConstructorValueFromData(mapData, form, tid) {
    mapData['cmnFormFieldEventList']?.forEach((event1) => {
      event1?.cmnEventExecutionList?.forEach((rule1) => {
        this.callRuleObject(rule1, form, mapData, tid);
      });
    });
  }
  GetValueFromData(mapData, form, tid, isAdvanceRule?, tabFieldId?) {
    mapData['cmnFormFieldEventList']?.forEach((event) => {
      event?.cmnEventExecutionList?.forEach((rule) => {
        this.callRuleObject(
          rule,
          form,
          mapData,
          tid,
          isAdvanceRule,
          tabFieldId
        );
      });
    });
  }
  callRuleObject(
    rule,
    form,
    mapData,
    tid,
    isAdvanceRule?,
    tabFieldId?,
    columnData?
  ) {
    let RuleValue;
    let CompIdthird;
    let OperatorValue;
    let VisibilityRulesList;
    let CompIdSecond;
    let CurrentValue;
    let CompIdFirst;
    CompIdFirst = mapData.fieldId;

    if (form?.controls[mapData.fieldId]?.value) {
      CurrentValue = form?.controls[mapData.fieldId]?.value;
    } else {
      CurrentValue = columnData;
    }

    if (rule?.cmnVisibilityRulesList) {
      RuleValue = rule?.cmnVisibilityRulesList[0]?.value;
      CompIdthird = rule?.cmnVisibilityRulesList[0]?.otherCmpFormId;
      OperatorValue = rule?.cmnVisibilityRulesList[0]?.operator;
      VisibilityRulesList =
        rule?.cmnVisibilityRulesList[0]?.cmnVisibilityRuleOutputList;
      // console.log(VisibilityRulesList);
      CompIdSecond =
        rule?.cmnVisibilityRulesList[0]?.cmnVisibilityRuleOutputList[0]
          ?.dependCmpFormId;
      this.RuleFun(
        CurrentValue,
        RuleValue,
        OperatorValue,
        VisibilityRulesList,
        CompIdFirst,
        CompIdSecond,
        CompIdthird,
        form,
        tid,
        mapData,
        isAdvanceRule,
        tabFieldId
      );
    }
  }
  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//

  RuleFun(
    CurrentValue,
    RuleValue,
    OperatorValue,
    VisibilityRulesList,
    CompIdFirst,
    CompIdSecond,
    CompIdthird,
    form,
    tid,
    mapData,
    isAdvanceRule?,
    tabFieldId?
  ) {
    //-----------------------------------------------------------------------------------------//
    //-----------------------------------------------------------------------------------------//
    //-----------------------------------------------------------------------------------------//

    let value1: any, value2: any;
    if (RuleValue) {
      // Compare By Value

      value1 =
        typeof CurrentValue == 'object'
          ? CurrentValue?.optionValue
          : CurrentValue;
      value2 = RuleValue;
    } else {
      //Compare by Component
      value1 = this.commonService?.appGenFormGroup?.controls[CompIdFirst]
        ?.value;
      value2 = this.commonService?.appGenFormGroup?.controls[CompIdthird]
        ?.value;
    }

    //-----------------------------------------------------------------------------------------//
    //-----------------------------------------------------------------------------------------//
    //-----------------------------------------------------------------------------------------//
    let comapreValue;
    if (tabFieldId) {
      if (tabFieldId == CompIdthird) {
        let successOuput = this.FilterOutputList(
          VisibilityRulesList,
          1,
          isAdvanceRule
        );

        this.setAction(successOuput, form, tid, mapData);
      }
    } else {
      // Compare Tow Value

      if (RuleValue || value2 || value1) {
        if (
          typeof RuleValue == 'string' &&
          mapData.fieldType != 0 &&
          mapData.fieldType != 19 &&
          mapData.fieldType != 81
        ) {
          //------------------------- Compare For String Value only

          if (OperatorValue == '!=') {
            comapreValue = value1 === value2 ? false : true;
          } else {
            comapreValue = value1 === value2 ? true : false;
          }
        } else if (mapData.fieldType == 0) {
          //------------------------- Compare For Date Value only

          // Change String Value Into Date
          const dateValueOne = new Date(value1);
          const dateValueTow = new Date(value2);

          if (OperatorValue == '<=') {
            comapreValue = dateValueOne <= dateValueTow;
          } else if (OperatorValue == '>=') {
            comapreValue = dateValueOne >= dateValueTow;
          } else if (OperatorValue == '==') {
            comapreValue = +dateValueOne == +dateValueTow;
          }
          //  not Working for Date -- comapreValue = eval(dateValueOne + OperatorValue + dateValueTow);
          console.log(comapreValue);
        } else if (mapData.fieldType == 19 || mapData.fieldType == 81) {
          let defaulValueArray = [];

          let value2Obj = value2?.split(',');

          value2Obj?.forEach(function (defaultValueObj) {
            if (defaultValueObj && Number(defaultValueObj)) {
              let object1 = mapData.attribute.comboMapValues?.find(
                (o) => o.optionValue === defaultValueObj && o.selected
              );
              if (object1) {
                defaulValueArray.push(object1);
              }
            }
          });
          if (
            value2Obj &&
            Array.isArray(value2Obj) &&
            value2Obj.length == defaulValueArray.length
          ) {
            comapreValue = true;
          } else {
            comapreValue = false;
          }
        } else {
          //------------------------- Compare For other Value only
          try {
            comapreValue = eval(value1 + OperatorValue + value2);
          } catch (error) {
            console.log('Error in eval function');
            comapreValue = false;
          }
        }

        if (comapreValue) {
          let successOuput = this.FilterOutputList(
            VisibilityRulesList,
            1,
            isAdvanceRule
          );

          this.setAction(successOuput, form, tid, mapData, isAdvanceRule);
        }
        if (!comapreValue) {
          let FailureOuput = this.FilterOutputList(
            VisibilityRulesList,
            0,
            isAdvanceRule
          );
          this.setAction(FailureOuput, form, tid, mapData, isAdvanceRule);
        }
      }
    }
  }
  setFocus(jsonObject, dependentCmt, selectedIndex, type) {
    if (type == 102) {
      this.getKeys(jsonObject).forEach((component) => {
        if (!Array.isArray(jsonObject[component])) {
          if (type == 102) {
            if (jsonObject[component].fieldId == dependentCmt) {
              let tabIndex = this.findTabIndex(
                jsonObject[component].children,
                selectedIndex
              );

              setTimeout(function () {
                jsonObject[component].attribute.selectedIndex = tabIndex;
              }, 1000);
            }
          }
        }
        if (Array.isArray(jsonObject[component])) {
          this.setFocus(
            jsonObject[component],
            dependentCmt,
            selectedIndex,
            type
          );
        }
        if (Array.isArray(jsonObject[component]?.children)) {
          this.setFocus(
            jsonObject[component]?.children,
            dependentCmt,
            selectedIndex,
            type
          );
        }
      });
    }
    return jsonObject;
  }

  findTabIndex(jsonObject, dependCmpIdValue) {
    let index;

    let hideCount = 0;
    this.getKeys(jsonObject).forEach((component: any) => {
      if (jsonObject[component]?.attribute?.hideShow) {
        hideCount = hideCount + 1;
      }
      if (jsonObject[component].fieldId == dependCmpIdValue) {
        index = component - hideCount;
        return component;
      }
    });
    return index;
  }

  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//

  // Filter the action On the bases Success
  FilterOutputList(VisibilityRulesList, SuccessOrFail, isAdvanceRule?) {
    let ActionSet = [];
    VisibilityRulesList?.forEach((value) => {
      if (value.isSuccess == SuccessOrFail || isAdvanceRule) {
        ActionSet.push(value);
      }
    });
    if (ActionSet && ActionSet.length != 0) {
      ActionSet = this.moveZerosToEnd(ActionSet);
    }

    return ActionSet;
  }
  moveZerosToEnd = (arr) => {
    return arr
      .filter((item) => item.action !== 'SetFocus')
      .concat(arr.filter((item) => item.action === 'SetFocus'));
  };
  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//

  // Get Action Value And Set Value In Component
  setAction(setActionData, form, tid, mapData, isAdvanceRule?) {
    setActionData?.forEach((value) => {
      let ActionValue = value.action;
      let dependCmpIdValue = value.dependCmpFormId;

      this.filterAtion(
        ActionValue,
        dependCmpIdValue,
        value,
        form,
        tid,
        mapData,
        isAdvanceRule
      );
    });
  }

  filterAtion(
    ActionValue,
    dependCmpIdValue,
    FieldvalueObj,
    form,
    tid,
    mapData,
    isAdvanceRule?
  ) {
    // Process Action
    this.processAction(
      dependCmpIdValue,
      this.getClassFromAction(
        ActionValue,
        FieldvalueObj,
        dependCmpIdValue,
        form,
        isAdvanceRule
      ),
      form,
      tid,
      mapData
    );
  }

  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//

  getClassFromAction(
    ActionValue,
    FieldvalueObj,
    dependCmpIdValue,
    form?,
    isAdvanceRule?
  ) {
    let classListValue = {
      addActionList: [],
      removeActionList: [],
      SetValueList: [],
    };
    switch (ActionValue) {
      case 'Show':
        classListValue.removeActionList.push('d-none');
        this.hideShowAttributeMap(
          this.commonService.inputJsonData,
          dependCmpIdValue,
          false,
          null,
          isAdvanceRule
        );

        //this.hideShowAction(dependCmpIdValue, false, form);
        break;
      case 'Hide':
        classListValue.addActionList.push('d-none');

        this.hideShowAttributeMap(
          this.commonService.inputJsonData,
          dependCmpIdValue,
          true,
          null,
          isAdvanceRule
        );
        break;
      case 'Hide with Initial Value':
        classListValue.addActionList.push('d-none');
        this.hideWithInitialValue(
          this.commonService.resultObj,
          dependCmpIdValue,
          true
        );

        break;
      case 'Enabled':
        classListValue.addActionList.push('false');
        this.commonService.compMap(
          this.commonService.resultObj,
          false,
          dependCmpIdValue
        );
        break;
      case 'Disabled':
        classListValue.addActionList.push('true');
        this.commonService.compMap(
          this.commonService.resultObj,
          true,
          dependCmpIdValue
        );
        break;
      case 'SetValue':
        classListValue.SetValueList.push(FieldvalueObj);
        break;
      case 'SetFocus':
        //classListValue.SetValueList.push(FieldvalueObj);
        let isComponentType = this.commonService.componentMap[dependCmpIdValue];
        this.setFocus(
          this.commonService.inputJsonData,
          dependCmpIdValue,
          FieldvalueObj.opValue,
          isComponentType
        );
        break;
      case 'Load Combo':
        classListValue.SetValueList.push(FieldvalueObj);
        break;
      case 'Mandatory':
        classListValue.SetValueList.push(FieldvalueObj);
        break;
      case 'Optional':
        classListValue.SetValueList.push(FieldvalueObj);
        break;
      case 'Generate Letter with Edit':
        classListValue.SetValueList.push(FieldvalueObj);
        break;
      case 'Call TS Funtion':
        classListValue.SetValueList.push(FieldvalueObj);
        break;
      case 'Notification':
        classListValue.SetValueList.push(FieldvalueObj);
        break;
      case 'ShowMessaage':
        classListValue.SetValueList.push(FieldvalueObj);
        break;

      default:
        console.log('Invalid value');
        break;
    }
    return classListValue;
  }

  hideWithInitialValue(jsonObject: any, dependCompId: any, action: any) {
    this.getKeys(jsonObject).forEach((component) => {
      if (!Array.isArray(jsonObject[component])) {
        if (jsonObject[component]?.fieldId == dependCompId) {
          jsonObject[component].attribute.hideShow = action;

          if (action) {
            if (this.commonService.appGenFormGroup.controls[dependCompId]) {
              let hideValueObj = this.commonService.appGenFormGroup.controls[
                dependCompId
              ].value;
              if (hideValueObj != null && hideValueObj != undefined) {
                jsonObject[
                  component
                ].tempDefaultValue = this.commonService.appGenFormGroup.controls[
                  dependCompId
                ].value;

                this.appGenServiceService.setAppGenData(
                  dependCompId,
                  jsonObject[component].tempDefaultValue
                );
                this.ConstructorValueFromData(
                  jsonObject[component],
                  this.commonService.appGenFormGroup,
                  this.commonService.tid
                );
              }
            }

            if (jsonObject[component]?.attribute?.isMandatory) {
              this.commonService?.appGenFormGroup?.controls[
                dependCompId
              ].clearValidators();
              this.commonService?.appGenFormGroup?.controls[
                dependCompId
              ].updateValueAndValidity();
            }
            if (jsonObject[component]?.children) {
              this.commonService.removeAndaddValidation(
                jsonObject[component]?.children,
                action
              );
            }
            this.ConstructorValueFromData(
              jsonObject[component],
              this.commonService.appGenFormGroup,
              this.commonService.tid
            );
          }
          if (!action) {
            if (this.commonService.eventId == 23) {
              this.appGenServiceService.setAppGenData(
                dependCompId,
                jsonObject[component].defaultValue
              );
            } else {
              this.appGenServiceService.setAppGenData(
                dependCompId,
                jsonObject[component].attribute.defaultValue
              );
            }

            this.ConstructorValueFromData(
              jsonObject[component],
              this.commonService.appGenFormGroup,
              this.commonService.tid
            );

            if (jsonObject[component]?.attribute?.isMandatory) {
              if (this.commonService?.appGenFormGroup?.controls[dependCompId]) {
                this.commonService.addValidators(
                  jsonObject[component],
                  dependCompId
                );
              }
            }
            if (jsonObject[component]?.children) {
              this.commonService.removeAndaddValidation(
                jsonObject[component]?.children,
                action
              );
            }
          }
          return;
        }
      }
      if (Array.isArray(jsonObject[component])) {
        this.hideWithInitialValue(jsonObject[component], dependCompId, action);
      }
      if (Array.isArray(jsonObject[component]?.children)) {
        this.hideWithInitialValue(
          jsonObject[component]?.children,
          dependCompId,
          action
        );
      }
    });
    return;
  }

  hideShowAttributeMap(
    jsonObject: any,
    dependCompId: any,
    action: any,
    parentField?,
    isAdvanceRule?
  ) {
    this.getKeys(jsonObject).forEach((component) => {
      if (!Array.isArray(jsonObject[component])) {
        if (jsonObject[component]?.fieldId == dependCompId) {
          if (isAdvanceRule) {
            setTimeout(function () {
              jsonObject[component].attribute.hideShow = action;
            }, 100);
          } else {
            jsonObject[component].attribute.hideShow = action;
          }
          if (jsonObject[component].fieldType == 94) {
            this.isDataTableHideShow(jsonObject[component].children, action);
          }
          if (jsonObject[component].fieldType == 94) {
            parentField.attribute.selectedIndex = !action ? +component : null;
            if (action) {
              this.commonService.nextTab = true;
            } else {
              this.commonService.nextTab = false;
            }
            // this.flagTab = false;
          }

          if (action) {
            if (this.commonService.appGenFormGroup.controls[dependCompId]) {
              let hideValueObj = this.commonService.appGenFormGroup.controls[
                dependCompId
              ].value;
              if (hideValueObj != null && hideValueObj != undefined) {
                jsonObject[
                  component
                ].tempDefaultValue = this.commonService.appGenFormGroup.controls[
                  dependCompId
                ].value;
                if (this.commonService.eventId == 23) {
                  jsonObject[component].defaultValue = '';
                } else {
                  jsonObject[component].attribute.defaultValue = '';
                }
                this.commonService.appGenFormGroup.controls[
                  dependCompId
                ].reset();
                delete this.appGenServiceService.appGenData[dependCompId];
                ///this.appGenServiceService.setAppGenData(dependCompId, '');
                this.ConstructorValueFromData(
                  jsonObject[component],
                  this.commonService.appGenFormGroup,
                  this.commonService.tid
                );
              }
            }
            if (jsonObject[component]?.attribute?.isMandatory) {
              this.commonService?.appGenFormGroup?.controls[
                dependCompId
              ].clearValidators();
              this.commonService?.appGenFormGroup?.controls[
                dependCompId
              ].updateValueAndValidity();
            }
            if (jsonObject[component]?.children) {
              this.commonService.removeAndaddValidation(
                jsonObject[component]?.children,
                action
              );
            }
          }
          if (!action) {
            if (jsonObject[component]?.tempDefaultValue) {
              let componenttype = this.commonService.componentMap[dependCompId];
              if (
                (componenttype == 98 ||
                  componenttype == 71 ||
                  componenttype == 81 ||
                  componenttype == 18 ||
                  componenttype == 90 ||
                  componenttype == 5) &&
                Number(jsonObject[component]?.tempDefaultValue)
              ) {
                if (this.commonService.eventId == 23) {
                  let value = jsonObject[
                    component
                  ]?.attribute?.comboMapValues?.filter(
                    (res) =>
                      res.optionValue == jsonObject[component]?.tempDefaultValue
                  );
                  if (value) {
                    jsonObject[component].defaultValue = value[0];
                    jsonObject[component].tempDefaultValue =
                      jsonObject[component].defaultValue;
                  }
                } else {
                  let value = jsonObject[
                    component
                  ]?.attribute?.comboMapValues?.filter(
                    (res) =>
                      res?.optionValue ==
                      jsonObject[component]?.tempDefaultValue
                  );
                  if (value) {
                    jsonObject[component].attribute.defaultValue = value[0];
                    jsonObject[component].tempDefaultValue =
                      jsonObject[component].attribute.defaultValue;
                  }
                }
              }
              this.commonService.appGenFormGroup.controls[
                dependCompId
              ].setValue(jsonObject[component]?.tempDefaultValue);
              this.appGenServiceService.setAppGenData(
                dependCompId,
                jsonObject[component]?.tempDefaultValue
              );
              if (this.commonService.eventId == 23) {
                jsonObject[component].defaultValue =
                  jsonObject[component]?.tempDefaultValue;
              } else {
                jsonObject[component].attribute.defaultValue =
                  jsonObject[component]?.tempDefaultValue;
              }
              this.ConstructorValueFromData(
                jsonObject[component],
                this.commonService.appGenFormGroup,
                this.commonService.tid
              );
            }
            //IF PARENT HIDE
            let parentId = this.commonService.getParentIdforTab(
              this.commonService.resultObj,
              jsonObject[component]?.attribute?.fieldId
            );
            let parentHideShow = this.commonService.isElementHideShow(
              this.commonService.resultObj,
              parentId
            );
            if (
              jsonObject[component]?.attribute?.isMandatory &&
              !parentHideShow
            ) {
              if (this.commonService?.appGenFormGroup?.controls[dependCompId]) {
                this.commonService.addValidators(
                  jsonObject[component],
                  dependCompId
                );
              }
            }
            if (jsonObject[component]?.children?.length == 0) {
              if (jsonObject[component]) {
                this.commonService.removeAndaddValidation(
                  [jsonObject[component]],
                  action
                );
              }
            }
            if (jsonObject[component]?.children) {
              this.commonService.removeAndaddValidation(
                jsonObject[component]?.children,
                action
              );
            }
          }
          return;
        }
      }
      if (Array.isArray(jsonObject[component])) {
        this.hideShowAttributeMap(
          jsonObject[component],
          dependCompId,
          action,
          isAdvanceRule
        );
      }
      if (Array.isArray(jsonObject[component]?.children)) {
        this.hideShowAttributeMap(
          jsonObject[component]?.children,
          dependCompId,
          action,
          jsonObject[component],
          isAdvanceRule
        );
      }
    });
    return;
  }
  getKeys(map: any) {
    if (map) return Object.keys(map);
  }

  isDataTableHideShow(jsonObject, action) {
    this.getKeys(jsonObject).forEach((component) => {
      if (!Array.isArray(jsonObject[component])) {
        if (jsonObject[component]?.fieldType == 12) {
          this.commonService.isDataTableHideShow[
            jsonObject[component]?.fieldId
          ] = action;
        }
      }

      if (Array.isArray(jsonObject[component])) {
        this.isDataTableHideShow(jsonObject[component], action);
      }
      if (Array.isArray(jsonObject[component]?.children)) {
        this.isDataTableHideShow(jsonObject[component]?.children, action);
      }
    });
    return jsonObject;
  }
  // Perform The Action In All Component On Bases Of Rule
  processAction(dependCmpId, classListValue, form, tid, mapData) {
    tid = tid != undefined ? tid : this.commonService.tid;

    let componenttype = this.commonService.componentMap[dependCmpId];
    // Set Value In Component Value
    classListValue?.SetValueList?.forEach((value) => {
      if (
        dependCmpId != undefined &&
        dependCmpId != null &&
        value.action != 'Mandatory' &&
        value.action != 'Optional' &&
        (componenttype == 3 ||
          componenttype == 1 ||
          componenttype == 10 ||
          componenttype == 44)
      ) {
        this.setTextFieldData(
          this.commonService.inputJsonData,
          dependCmpId,
          value.opValue
        );

        this.appGenServiceService.setAppGenData(dependCmpId, value.opValue);
      } else if (
        (componenttype == 98 ||
          componenttype == 71 ||
          componenttype == 81 ||
          componenttype == 5) &&
        value.action == 'Load Combo'
      ) {
        this.appGenServiceService
          .getComboIds(value.opValue.toString())
          .subscribe((response: any) => {
            this.commonService?.appGenFormGroup?.controls[dependCmpId].reset();
            this.setDropDownData(
              this.commonService.inputJsonData,
              dependCmpId,
              response,
              value.action
            );
          });
      } else if (
        (componenttype == 98 ||
          componenttype == 18 ||
          componenttype == 71 ||
          componenttype == 81 ||
          componenttype == 19 ||
          componenttype == 5) &&
        value.action == 'SetValue'
      ) {
        // console.log("onload",this.commonService.onLoadEvent);
        if (this.commonService.onLoadEvent == true) {
          setTimeout(() => {
            this.setDropDownData(
              this.commonService.inputJsonData,
              dependCmpId,
              value.opValue.toString(),
              value.action
            );
          }, 500);
        } else {
          this.setDropDownData(
            this.commonService.inputJsonData,
            dependCmpId,
            value.opValue.toString(),
            value.action
          );
        }
      }
    });

    classListValue?.SetValueList?.forEach((value) => {
      let componenttype = this.commonService.componentMap[dependCmpId];
      switch (value.action) {
        case 'Generate Letter with Edit':
          this.callGenerateDraft(tid, value);
          break;
        case 'Call TS Funtion':
          this.commonService.callUserdefindFunction(value.functionName);
          break;
        case 'Mandatory':
          if (componenttype == 12) {
            this.commonService.isMandatoryComponentMap[dependCmpId] = true;
            this.setDataTable(
              this.commonService.inputJsonData,
              dependCmpId,
              true
            );
          } else {
            this.commonService?.appGenFormGroup?.controls[
              dependCmpId
            ].clearValidators();
            this.commonService?.appGenFormGroup?.controls[
              dependCmpId
            ].setValidators([Validators.required]);
            this.commonService?.appGenFormGroup?.controls[
              dependCmpId
            ].updateValueAndValidity();
          }
          break;
        case 'Optional':
          if (componenttype == 12) {
            this.commonService.isMandatoryComponentMap[dependCmpId] = false;
            this.setDataTable(
              this.commonService.inputJsonData,
              dependCmpId,
              false
            );
          } else {
            this.commonService?.appGenFormGroup?.controls[
              dependCmpId
            ].clearValidators();
            this.commonService?.appGenFormGroup?.controls[
              dependCmpId
            ].updateValueAndValidity();
          }
          break;
        case 'Notification':
          this.callNotification(value);
          break;
        case 'ShowMessage':
          this.callShowMessage(value);
          break;
        default:
          console.log('Invalid value');
          break;
      }
    });
  }
  setDropDownData(jsonObject, dependCompId, resultObj, action) {
    this.getKeys(jsonObject).forEach((component) => {
      if (!Array.isArray(jsonObject[component])) {
        let componenttype = this.commonService.componentMap[dependCompId];
        if (
          jsonObject[component]?.fieldId == dependCompId &&
          action == 'Load Combo'
        ) {
          jsonObject[component].attribute.comboMapValues = [];
          jsonObject[component].attribute.comboMapValues = resultObj;
          return jsonObject[component];
        } else if (
          jsonObject[component]?.fieldId == dependCompId &&
          action == 'SetValue' &&
          componenttype != 19 &&
          componenttype != 81
        ) {
          if (jsonObject[component]?.attribute?.comboMapValues) {
            if (this.commonService.eventId != 23) {
              let value = jsonObject[component].attribute.comboMapValues.find(
                (o) => o.optionValue === resultObj
              );
              jsonObject[component].attribute.defaultValue = value;
              this.appGenServiceService.setAppGenData(dependCompId, value);
              this.commonService.appGenFormGroup?.controls[
                jsonObject[component].fieldId
              ]?.setValue(value);
              this.ConstructorValueFromData(
                jsonObject[component],
                this.commonService.appGenFormGroup,
                this.commonService.tid
              );
            } else {
              let value = jsonObject[component].attribute.comboMapValues.find(
                (o) => o.optionValue === resultObj
              );
              jsonObject[component].defaultValue = value;
              this.appGenServiceService.setAppGenData(dependCompId, value);
              this.commonService.appGenFormGroup?.controls[
                jsonObject[component].fieldId
              ]?.setValue(value);
              this.ConstructorValueFromData(
                jsonObject[component],
                this.commonService.appGenFormGroup,
                this.commonService.tid
              );
            }
          }
          return jsonObject[component];
        } else if (
          jsonObject[component]?.fieldId == dependCompId &&
          action == 'SetValue' &&
          componenttype == 19
        ) {
          let defaultObj = resultObj.split(',');

          jsonObject[component].defaultValue = [];

          defaultObj?.forEach((v1, i1) => {
            jsonObject[component]?.attribute?.comboMapValues?.forEach(
              (v, i) => {
                if (defaultObj[i1] == v.optionValue) {
                  jsonObject[component]?.defaultValue.push(v);
                }
              }
            );
          });
          let defaulValueArray = this.commonService.appGenFormGroup?.controls[
            jsonObject[component].fieldId
          ]?.value;
          this.appGenServiceService.setAppGenData(
            jsonObject[component]?.fieldId,
            defaulValueArray
          );
          this.ConstructorValueFromData(
            jsonObject[component],
            this.commonService.appGenFormGroup,
            this.commonService.tid
          );
          return jsonObject[component];
        } else if (
          jsonObject[component]?.fieldId == dependCompId &&
          action == 'SetValue' &&
          componenttype == 81
        ) {
          let defaulValueArray = [];
          let defaultVal = resultObj;
          jsonObject[component].attribute.MultiselectValue = defaultVal?.split(
            ','
          );
          let comboMapValues = jsonObject[component]?.attribute?.comboData;
          defaultVal?.split(',')?.forEach(function (defaultValueObj) {
            if (defaultValueObj && Number(defaultValueObj)) {
              let valueObj = comboMapValues?.find(
                (o) => o.optionValue === defaultValueObj
              );
              if (valueObj) {
                defaulValueArray.push(valueObj);
              }
            }
          });
          if (
            defaulValueArray &&
            Array.isArray(defaulValueArray) &&
            defaulValueArray.length != 0
          ) {
            this.appGenServiceService.setAppGenData(
              jsonObject[component]?.fieldId,
              defaulValueArray
            );
            this.ConstructorValueFromData(
              jsonObject[component],
              this.commonService.appGenFormGroup,
              this.commonService.tid
            );
          }
          return jsonObject[component];
        }
      }

      if (Array.isArray(jsonObject[component]?.children)) {
        this.setDropDownData(
          jsonObject[component]?.children,
          dependCompId,
          resultObj,
          action
        );
      }
    });
    return jsonObject;
  }
  setTextFieldData(jsonObject, dependCompId, value1) {
    this.getKeys(jsonObject).forEach((component) => {
      if (!Array.isArray(jsonObject[component])) {
        if (jsonObject[component]?.fieldId == dependCompId) {
          if (this.commonService.eventId == 23) {
            jsonObject[component].defaultValue = value1;
          } else {
            jsonObject[component].attribute.defaultValue = value1;
          }

          return;
        }
      }

      if (Array.isArray(jsonObject[component]?.children)) {
        this.setTextFieldData(
          jsonObject[component]?.children,
          dependCompId,

          value1
        );
      }
    });
    return jsonObject;
  }
  setDataTable(jsonObject, dependCompId, action) {
    this.getKeys(jsonObject).forEach((component) => {
      if (!Array.isArray(jsonObject[component])) {
        if (jsonObject[component]?.fieldId == dependCompId) {
          this.addDataTableFieldMandatory(jsonObject[component], action);
          return;
        }
      }

      if (Array.isArray(jsonObject[component]?.children)) {
        this.setDataTable(
          jsonObject[component]?.children,
          dependCompId,

          action
        );
      }
    });
    return jsonObject;
  }
  addDataTableFieldMandatory(jsonObject, action) {
    this.getKeys(jsonObject).forEach((component) => {
      if (!Array.isArray(jsonObject[component])) {
        if (action && jsonObject[component]?.attribute?.isMandatory) {
          this.commonService?.appGenFormGroup?.controls[
            jsonObject[component].fieldId
          ].clearValidators();
          this.commonService?.appGenFormGroup?.controls[
            jsonObject[component].fieldId
          ].setValidators([Validators.required]);
          this.commonService?.appGenFormGroup?.controls[
            jsonObject[component].fieldId
          ].updateValueAndValidity();
        }
        if (!action && jsonObject[component]?.attribute?.isMandatory) {
          this.commonService?.appGenFormGroup?.controls[
            jsonObject[component].fieldId
          ].clearValidators();
          this.commonService?.appGenFormGroup?.controls[
            jsonObject[component].fieldId
          ].updateValueAndValidity();
        }
      }

      if (Array.isArray(jsonObject[component]?.children)) {
        this.addDataTableFieldMandatory(
          jsonObject[component]?.children,
          action
        );
      }
    });
    return jsonObject;
  }
  callNotification(value) {
    this.commonService.callNotification(value.notificationTmpltId);
  }
  callShowMessage(value) {
    this.commonService.callShowMessage(value.notificationTmpltId);
  }
  callGenerateDraft(tid, value) {
    this.commonService.getDraftData(
      this.commonService.FORMID,
      tid,
      value,
      this.commonService.appId
    );
  }
}
